/* Reports */
export const GET_STARTUPS = "GET_STARTUPS";
export const GET_STARTUPS_FAIL = "GET_STARTUPS_FAIL";
export const GET_STARTUPS_SUCCESS = "GET_STARTUPS_SUCCESS";

export const GET_STARTUP_DEALS = "GET_STARTUP_DEALS";
export const GET_STARTUP_DEALS_FAIL = "GET_STARTUP_DEALS_FAIL";
export const GET_STARTUP_DEALS_SUCCESS = "GET_STARTUP_DEALS_SUCCESS";
